import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getDivisions } from '../api'
import { useQuery } from 'react-query'

export const useGetDivisionsOnMount = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      setStatus('pending')
      try {
        const result = await dispatch(getDivisions())
        if (mounted) {
          if (getDivisions.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}

export const useGetDivisionsOnMountCached = () => {
  const dispatch = useAppDispatch()

  const { data, ...rest } = useQuery('divisions', async () => {
    await dispatch(getDivisions())
  })

  return rest
}
